import { render, staticRenderFns } from "./MedicineAdvantage.vue?vue&type=template&id=058d5220&"
import script from "./MedicineAdvantage.vue?vue&type=script&lang=js&"
export * from "./MedicineAdvantage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports